import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar, faComments, faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add(faCalendar, faComments, faPlusSquare)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)



// WEBPACK FOOTER //
// ./src/fa.config.js